export const iconFontAwesomeShoppingPersonBooth = (
	<i className="fa-solid fa-person-booth"></i>
);
